import { Directive, ElementRef, Injectable, OnInit } from "@angular/core";

@Directive({
    selector: "[app-autoFocus]",
    standalone: true,
})
@Injectable()
export class AutoFocusDirective implements OnInit {
    private inputElement: HTMLInputElement;

    constructor(private elementRef: ElementRef) {
        this.inputElement = this.elementRef.nativeElement;
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.inputElement.focus();
            // var ctrlEvent = new KeyboardEvent("keydown", { bubbles: true, cancelable: true, keyCode: 17, shiftKey: true });
            // var aEvent = new KeyboardEvent("keydown", { bubbles: true, cancelable: true, keyCode: 65,  shiftKey: true });

            // this.inputElement.dispatchEvent(ctrlEvent);
            // this.inputElement.dispatchEvent(aEvent);
        }, 1);
    }
}
